// @flow
import { createSelector } from 'reselect';
import { get, some } from 'lodash';

const getServiceProviderId = state => state.serviceProviderId;
const getServiceProviderCache = state => state.serviceProviderCache;
const getAdAgreements = state => get(state, 'adAgreement.fetchAgreementsByServiceProviderId', {});

export type UpgradeStateType = 'paid' | 'pending' | 'free' | 'loading';

export const PAID_UPGRADE_STATE: UpgradeStateType = 'paid';
export const PENDING_UPGRADE_STATE: UpgradeStateType = 'pending';
export const FREE_UPGRADE_STATE: UpgradeStateType = 'free';
export const LOADING_UPGRADE_STATE: UpgradeStateType = 'loading';

export const getServiceProviderUpgradeState: (state: any) => UpgradeStateType = createSelector(
  [getServiceProviderId, getServiceProviderCache, getAdAgreements],
  (serviceProviderId, serviceProviderCache, fetchAgreements) => {
    const isAdvertiser = get(serviceProviderCache, `${serviceProviderId}.isAdvertiser`, false);
    const agreementStatusList = get(fetchAgreements, 'response.agreementStatusList', []);
    const hasAcceptedAgreement = some(agreementStatusList, { agreementStatus: 'Accepted' });
    const hasActiveAgreement = some(agreementStatusList, { agreementStatus: 'Active' });

    if (isAdvertiser || hasActiveAgreement) {
      return PAID_UPGRADE_STATE;
    }

    if (hasAcceptedAgreement) {
      return PENDING_UPGRADE_STATE;
    }

    if (fetchAgreements.isLoading) {
      return LOADING_UPGRADE_STATE;
    }

    return FREE_UPGRADE_STATE;
  },
);

export default {
  getServiceProviderUpgradeState,
};



// WEBPACK FOOTER //
// ./src/modules/home/common/selectors/upgradeStateSelectors.js